import { CombinedFlows, TransactionTypes } from "./flow-types";

// Helper functions to reduce cognitive complexity
const hasMyPrincipals = (myPrincipals) => myPrincipals && myPrincipals.length > 0;

const hasOnBehalfOf = (onBehalfOf) => onBehalfOf?.id;

const isOnBehalfOfSelf = (onBehalfOf, identity) =>
	onBehalfOf?.id === identity?.organization?.id;

const isOnBehalfOfOther = (onBehalfOf, identity) =>
	onBehalfOf && onBehalfOf.id !== identity?.organization?.id;

// Flow resolvers for each combined flow type
const flowResolvers = {
	[CombinedFlows.CONTRIBUTOR_ONLY]: () => CombinedFlows.CONTRIBUTOR_ONLY,
	[CombinedFlows.POB_ONLY]: () => CombinedFlows.POB_ONLY,
	[CombinedFlows.POBOP_ONLY]: () => CombinedFlows.POBOP_ONLY,

	[CombinedFlows.CONTRIBUTOR_POB]: (selections, identity) => {
		const { onBehalfOf } = selections;
		if (isOnBehalfOfSelf(onBehalfOf, identity)) return CombinedFlows.CONTRIBUTOR_ONLY;
		if (isOnBehalfOfOther(onBehalfOf, identity)) return CombinedFlows.POB_ONLY;
		return CombinedFlows.CONTRIBUTOR_POB;
	},

	[CombinedFlows.POB_POBOP]: (selections, identity) => {
		const { onBehalfOf, myPrincipals } = selections;
		if (hasMyPrincipals(myPrincipals)) return CombinedFlows.POBOP_ONLY;
		if (hasOnBehalfOf(onBehalfOf) && isOnBehalfOfOther(onBehalfOf, identity)) {
			return CombinedFlows.POB_ONLY;
		}
		return CombinedFlows.POB_POBOP;
	},

	[CombinedFlows.CONTRIBUTOR_POBOP]: (selections) => {
		const { myPrincipals } = selections;
		if (hasMyPrincipals(myPrincipals)) return CombinedFlows.POBOP_ONLY;
		return CombinedFlows.CONTRIBUTOR_ONLY;
	},

	[CombinedFlows.CONTRIBUTOR_POB_POBOP]: (selections, identity) => {
		const { onBehalfOf, myPrincipals } = selections;
		if (hasMyPrincipals(myPrincipals)) return CombinedFlows.POBOP_ONLY;
		if (hasOnBehalfOf(onBehalfOf)) {
			return isOnBehalfOfOther(onBehalfOf, identity)
				? CombinedFlows.POB_ONLY
				: CombinedFlows.CONTRIBUTOR_ONLY;
		}
		return CombinedFlows.CONTRIBUTOR_POB_POBOP;
	},
};

export function getActiveFlow(
	combinedFlow,
	selections,
	identity,
	transactionType = TransactionTypes.PUSH_STORE
) {
	const { onBehalfOf } = selections;

	// Handle PUSH_TO_AGENT transaction type
	if (transactionType === TransactionTypes.PUSH_TO_AGENT) {
		return isOnBehalfOfOther(onBehalfOf, identity)
			? CombinedFlows.POB_ONLY
			: CombinedFlows.CONTRIBUTOR_ONLY;
	}

	// PUSH_STORE transaction type logic using flow resolvers
	const resolver = flowResolvers[combinedFlow];
	return resolver ? resolver(selections, identity) : CombinedFlows.CONTRIBUTOR_ONLY;
}
